"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToNumber = void 0;
var stringToNumber = function (numberlike) {
    var result = Number(numberlike);
    return Number.isNaN(result) ? undefined : result;
};
exports.stringToNumber = stringToNumber;
